import React from 'react';
import { HeroSection } from './components/HeroSection';
import { MetricsTestimonialsSection } from './components/MetricsTestimonialsSection';
import { PainSection } from './components/PainSection';
import { TransitionHookSection } from './components/TransitionHookSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ModulesSection } from './components/ModulesSection';
import { ModuleInclusionsSection } from './components/ModuleInclusionsSection';
import { BonusesSection } from './components/BonusesSection';
import { BonusValueSection } from './components/BonusValueSection';
import { UrgencySection } from './components/UrgencySection';
import { PriceSection } from './components/PriceSection';
import { ExtendedTestimonialsSection } from './components/ExtendedTestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="font-sans text-biosync-text bg-white min-h-screen" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <HeroSection data-id="element-2" />
      <MetricsTestimonialsSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <TransitionHookSection data-id="element-5" />
      <ProductIntroSection data-id="element-6" />
      <ModulesSection data-id="element-7" />
      <ModuleInclusionsSection data-id="element-8" />
      <BonusesSection data-id="element-9" />
      <BonusValueSection data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <PriceSection data-id="element-12" />
      <ExtendedTestimonialsSection data-id="element-13" />
      <GuaranteeSection data-id="element-14" />
      <FaqSection data-id="element-15" />
      <ComparisonSection data-id="element-16" />
      <FinalCtaSection data-id="element-17" />
      <FooterSection data-id="element-18" />
    </div>;
}